import { render } from "./OrderListPage.vue?vue&type=template&id=c795bcc2&ts=true"
import script from "./OrderListPage.vue?vue&type=script&lang=ts"
export * from "./OrderListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__